import React from 'react';
import team from './img/amagroup_team.jpg';

let projects = {
  name: "Проекты?",
  content: [
    {
      type: "their",
      link: "https://spbguru.ru",
      text: <span><span className="Bubble__link">СПБгуру</span> — каталог новостроек Санкт&#8209;Петербурга и Ленобласти</span>
    },
    {
      type: "their",
      link: "https://mskguru.ru",
      text: <span><span className="Bubble__link">МСКгуру</span> — каталог новостроек Москвы и Подмосковья</span>
    },
    {
      type: "their",
      link: "https://ama.ru",
      text: <span><span className="Bubble__link">Ама.ру</span> — сервис для поиска квартиры в новостройке</span>},
  ]
};
let who = {
  name: "Кто вы?",
  content: [
    {type: "their", text: <span>Мы команда специалистов, совмещающих творче&shy;ство и&nbsp;технологии</span>},
    {type: "their", img: <img width="225" height="225" src={team} alt="Команда amagroup"/> },
    {type: "their", text: <span>Наша миссия —&nbsp;создание самых удобных и&nbsp;красивых IT-решений как для жизни, так и&nbsp;для&nbsp;бизнеса</span>},
  ]
};

let contacts = {
  name: "Как с вами связаться?",
  content: [
    {
      type: "their",
      link: "tel:+79319791595",
      text: <span className="Bubble__link">+7 931 979 15 95</span>
    },
    {
      type: "their",
      link: "mailto:hello@amagroup.ru",
      text: <span className="Bubble__link">hello@amagroup.ru</span>
    },
    {
      type: "their",
      link: "https://spb.hh.ru/employer/1872490",
      text: <span className="Bubble__link">Наши вакансии</span>
    },
    {type: "their", text: <span className="Bubble__with-emoji">Ждём!😉</span>}
  ],
  children: []
};

export const Scenario = {
  name: "Hi",
  content: [
    {type: "their", text: <span className="Bubble__with-emoji">Привет!<span className="Bubble__emoji">✌️</span></span>},
    {type: "their", text: <span>Мы создаём и ведём свои проекты в интернете</span>},
  ],
  children: [
    {...projects,
      content: [{type: "their", text: "О ДАА! Поехали"}, ...projects.content],
      children: [
        {...who, name: "Неплохо. Кто вы?", children: [contacts]},
        contacts
      ]
    },
    {...who,
      children: [
        {...projects, name: "Заинтриговали, что там у вас?", mobile_name: 'Покажите проекты', children: [contacts]},
        contacts
      ]
    }
  ]
};



/** WEBPACK FOOTER **
 ** ./src/Scenario.js
 **/